var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeS5P2Img13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_324",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.38623,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9873 37.5909V33.8989H39.0127V37.591L16.9873 37.5909ZM18.654 32.2322C18.654 29.8892 19.3623 27.8592 20.779 26.1421C22.1957 24.425 23.9873 23.3521 26.154 22.9233V22.0212C26.154 21.5091 26.332 21.0734 26.688 20.7141C27.0439 20.3548 27.4796 20.1752 27.995 20.1752C28.5104 20.1752 28.9478 20.3548 29.3071 20.7141C29.6664 21.0734 29.846 21.5091 29.846 22.0212V22.9233C31.9916 23.3521 33.7779 24.425 35.2052 26.1421C36.6324 27.8592 37.346 29.8892 37.346 32.2322H18.654ZM23.6368 28.5085H32.2799C31.7787 27.8648 31.159 27.347 30.4209 26.955C29.6827 26.5632 28.8758 26.3672 28 26.3672C27.1063 26.3672 26.2809 26.5632 25.524 26.955C24.7671 27.347 24.138 27.8648 23.6368 28.5085ZM1.76813 22.0928V3.15159H12.2265V5.51847L23.7536 2.29834L37.3958 6.55467V7.8228C37.3958 9.64347 36.8981 11.0366 35.9026 12.0021C34.9072 12.9677 33.6286 13.4505 32.067 13.4505H29.0625V14.3509C29.0625 15.1435 28.8345 15.8647 28.3786 16.5146C27.9227 17.1645 27.3288 17.6311 26.5969 17.9143L15.3968 22.0928H1.76813ZM5.40038 18.4505H8.58425V6.78384H5.40038V18.4505ZM12.2265 18.4505H14.7536L24.4203 14.9088C24.7258 14.7977 24.9689 14.6102 25.1495 14.3463C25.33 14.0825 25.4203 13.7838 25.4203 13.4505H22.452L17.5853 15.0338L16.587 11.8672L21.7554 10.1172H32.0645C32.3149 10.1172 32.6279 10.0269 33.0036 9.84634C33.3792 9.66579 33.567 9.45051 33.567 9.20051L23.6703 6.11717L12.2265 9.25396V18.4505Z",
    fill: "#B84031"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeS5P2Img13);
export default __webpack_public_path__ + "static/media/HomeS5P2Img13.c4c1923e24f8dd4ce2d300c0c6577a61.svg";
export { ForwardRef as ReactComponent };